var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-wrapper container-xxl p-0" }, [
    _c("div", { staticClass: "content-header row" }),
    _c(
      "div",
      { staticClass: "content-body" },
      [
        _vm.loading
          ? _c(
              "div",
              { staticClass: "d-flex justify-content-center" },
              [
                _c("b-spinner", {
                  staticStyle: { width: "3rem", height: "3rem" },
                  attrs: { variant: "success", label: "Spinning" },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "row" },
          _vm._l(_vm.itemuom, function (config) {
            return _c(
              "div",
              { key: config.key, staticClass: "col-xl-4 col-lg-6 col-md-6" },
              [
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between align-items-end mt-1 pt-25",
                      },
                      [
                        _c("div", [
                          _c("h4", { staticClass: "fw-bolder" }, [
                            _vm._v(_vm._s(config.moduleName)),
                          ]),
                          _c("h5", { staticClass: "fw-bolder" }, [
                            _vm._v(_vm._s(config.key)),
                          ]),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              on: {
                                click: function ($event) {
                                  return _vm.openEditModal(config)
                                },
                              },
                            },
                            [_vm._v(" Edit ")]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
        _c(
          "b-modal",
          {
            attrs: {
              id: "edit-modal",
              title: "Edit Module Config",
              "hide-footer": "",
            },
            model: {
              value: _vm.isModalVisible,
              callback: function ($$v) {
                _vm.isModalVisible = $$v
              },
              expression: "isModalVisible",
            },
          },
          [
            _c(
              "div",
              [
                _c("h5", [
                  _vm._v("Module Name:"),
                  _c("p", [_vm._v(_vm._s(_vm.selectedConfig.moduleName))]),
                ]),
                _c(
                  "b-form-group",
                  { attrs: { label: "Value:", "label-for": "value-input" } },
                  [
                    _c(
                      "div",
                      { staticClass: "tags-field" },
                      [
                        _vm._l(_vm.tagValues, function (tag, index) {
                          return _c("div", { key: index, staticClass: "tag" }, [
                            _vm._v(" " + _vm._s(tag) + " "),
                            _c(
                              "button",
                              {
                                staticClass: "btn-close",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.removeTag(index)
                                  },
                                },
                              },
                              [_vm._v(" × ")]
                            ),
                          ])
                        }),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newTag,
                              expression: "newTag",
                            },
                          ],
                          staticClass: "tag-input",
                          attrs: {
                            type: "text",
                            placeholder: "Add and press Enter",
                          },
                          domProps: { value: _vm.newTag },
                          on: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.addTag($event)
                            },
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.newTag = $event.target.value
                            },
                          },
                        }),
                      ],
                      2
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "secondary" },
                        on: { click: _vm.closeModal },
                      },
                      [_vm._v("Cancel")]
                    ),
                    _c(
                      "b-button",
                      {
                        staticClass: "ml-2",
                        attrs: { type: "submit", variant: "success" },
                        on: { click: _vm.saveChanges },
                      },
                      [_vm._v(" Save ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }